/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CompleteDraftProcessParams,
  DraftProcessDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getDraftProcessById = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DraftProcessDTO>(
      {url: `/api/draftprocess/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDraftProcessByIdQueryKey = (id?: string,) => {
    return [`/api/draftprocess/${id}`] as const;
    }

    
export const getGetDraftProcessByIdQueryOptions = <TData = Awaited<ReturnType<typeof getDraftProcessById>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftProcessByIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDraftProcessById>>> = ({ signal }) => getDraftProcessById(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDraftProcessByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDraftProcessById>>>
export type GetDraftProcessByIdQueryError = unknown


export function useGetDraftProcessById<TData = Awaited<ReturnType<typeof getDraftProcessById>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDraftProcessById>>,
          TError,
          Awaited<ReturnType<typeof getDraftProcessById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDraftProcessById<TData = Awaited<ReturnType<typeof getDraftProcessById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDraftProcessById>>,
          TError,
          Awaited<ReturnType<typeof getDraftProcessById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDraftProcessById<TData = Awaited<ReturnType<typeof getDraftProcessById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDraftProcessById<TData = Awaited<ReturnType<typeof getDraftProcessById>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDraftProcessByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateDraftProcess = (
    id: string,
    draftProcessDTO: DraftProcessDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DraftProcessDTO>(
      {url: `/api/draftprocess/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: draftProcessDTO
    },
      options);
    }
  


export const getUpdateDraftProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftProcess>>, TError,{id: string;data: DraftProcessDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDraftProcess>>, TError,{id: string;data: DraftProcessDTO}, TContext> => {

const mutationKey = ['updateDraftProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDraftProcess>>, {id: string;data: DraftProcessDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  updateDraftProcess(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateDraftProcessMutationResult = NonNullable<Awaited<ReturnType<typeof updateDraftProcess>>>
    export type UpdateDraftProcessMutationBody = DraftProcessDTO
    export type UpdateDraftProcessMutationError = unknown

    export const useUpdateDraftProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDraftProcess>>, TError,{id: string;data: DraftProcessDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateDraftProcess>>,
        TError,
        {id: string;data: DraftProcessDTO},
        TContext
      > => {

      const mutationOptions = getUpdateDraftProcessMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const deleteDraftProcess = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<null>(
      {url: `/api/draftprocess/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteDraftProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftProcess>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDraftProcess>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteDraftProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDraftProcess>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDraftProcess(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDraftProcessMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDraftProcess>>>
    
    export type DeleteDraftProcessMutationError = unknown

    export const useDeleteDraftProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDraftProcess>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDraftProcess>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteDraftProcessMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getAllDraftProcesses = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DraftProcessDTO[]>(
      {url: `/api/draftprocess`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAllDraftProcessesQueryKey = () => {
    return [`/api/draftprocess`] as const;
    }

    
export const getGetAllDraftProcessesQueryOptions = <TData = Awaited<ReturnType<typeof getAllDraftProcesses>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDraftProcesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllDraftProcessesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllDraftProcesses>>> = ({ signal }) => getAllDraftProcesses(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllDraftProcesses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllDraftProcessesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllDraftProcesses>>>
export type GetAllDraftProcessesQueryError = unknown


export function useGetAllDraftProcesses<TData = Awaited<ReturnType<typeof getAllDraftProcesses>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDraftProcesses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDraftProcesses>>,
          TError,
          Awaited<ReturnType<typeof getAllDraftProcesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllDraftProcesses<TData = Awaited<ReturnType<typeof getAllDraftProcesses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDraftProcesses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllDraftProcesses>>,
          TError,
          Awaited<ReturnType<typeof getAllDraftProcesses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllDraftProcesses<TData = Awaited<ReturnType<typeof getAllDraftProcesses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDraftProcesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllDraftProcesses<TData = Awaited<ReturnType<typeof getAllDraftProcesses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllDraftProcesses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllDraftProcessesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createDraftProcess = (
    draftProcessDTO: DraftProcessDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DraftProcessDTO>(
      {url: `/api/draftprocess`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: draftProcessDTO, signal
    },
      options);
    }
  


export const getCreateDraftProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraftProcess>>, TError,{data: DraftProcessDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createDraftProcess>>, TError,{data: DraftProcessDTO}, TContext> => {

const mutationKey = ['createDraftProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDraftProcess>>, {data: DraftProcessDTO}> = (props) => {
          const {data} = props ?? {};

          return  createDraftProcess(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateDraftProcessMutationResult = NonNullable<Awaited<ReturnType<typeof createDraftProcess>>>
    export type CreateDraftProcessMutationBody = DraftProcessDTO
    export type CreateDraftProcessMutationError = unknown

    export const useCreateDraftProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDraftProcess>>, TError,{data: DraftProcessDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createDraftProcess>>,
        TError,
        {data: DraftProcessDTO},
        TContext
      > => {

      const mutationOptions = getCreateDraftProcessMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const completeDraftProcess = (
    id: string,
    params?: CompleteDraftProcessParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DraftProcessDTO>(
      {url: `/api/draftprocess/${id}/complete`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getCompleteDraftProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeDraftProcess>>, TError,{id: string;params?: CompleteDraftProcessParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeDraftProcess>>, TError,{id: string;params?: CompleteDraftProcessParams}, TContext> => {

const mutationKey = ['completeDraftProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeDraftProcess>>, {id: string;params?: CompleteDraftProcessParams}> = (props) => {
          const {id,params} = props ?? {};

          return  completeDraftProcess(id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompleteDraftProcessMutationResult = NonNullable<Awaited<ReturnType<typeof completeDraftProcess>>>
    
    export type CompleteDraftProcessMutationError = unknown

    export const useCompleteDraftProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeDraftProcess>>, TError,{id: string;params?: CompleteDraftProcessParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof completeDraftProcess>>,
        TError,
        {id: string;params?: CompleteDraftProcessParams},
        TContext
      > => {

      const mutationOptions = getCompleteDraftProcessMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const cancelDraftProcess = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DraftProcessDTO>(
      {url: `/api/draftprocess/${id}/cancel`, method: 'POST', signal
    },
      options);
    }
  


export const getCancelDraftProcessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDraftProcess>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelDraftProcess>>, TError,{id: string}, TContext> => {

const mutationKey = ['cancelDraftProcess'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelDraftProcess>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  cancelDraftProcess(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelDraftProcessMutationResult = NonNullable<Awaited<ReturnType<typeof cancelDraftProcess>>>
    
    export type CancelDraftProcessMutationError = unknown

    export const useCancelDraftProcess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelDraftProcess>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelDraftProcess>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCancelDraftProcessMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getDraftProcessesByUserId = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DraftProcessDTO[]>(
      {url: `/api/draftprocess/user/${userId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDraftProcessesByUserIdQueryKey = (userId?: string,) => {
    return [`/api/draftprocess/user/${userId}`] as const;
    }

    
export const getGetDraftProcessesByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError = unknown>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftProcessesByUserIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDraftProcessesByUserId>>> = ({ signal }) => getDraftProcessesByUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDraftProcessesByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDraftProcessesByUserId>>>
export type GetDraftProcessesByUserIdQueryError = unknown


export function useGetDraftProcessesByUserId<TData = Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError = unknown>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDraftProcessesByUserId>>,
          TError,
          Awaited<ReturnType<typeof getDraftProcessesByUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDraftProcessesByUserId<TData = Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDraftProcessesByUserId>>,
          TError,
          Awaited<ReturnType<typeof getDraftProcessesByUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDraftProcessesByUserId<TData = Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDraftProcessesByUserId<TData = Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDraftProcessesByUserIdQueryOptions(userId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDraftProcessesByUserIdAndReferenceCode = (
    userId: string,
    referenceCode: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DraftProcessDTO[]>(
      {url: `/api/draftprocess/user/${userId}/reference/${referenceCode}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDraftProcessesByUserIdAndReferenceCodeQueryKey = (userId?: string,
    referenceCode?: string,) => {
    return [`/api/draftprocess/user/${userId}/reference/${referenceCode}`] as const;
    }

    
export const getGetDraftProcessesByUserIdAndReferenceCodeQueryOptions = <TData = Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError = unknown>(userId: string,
    referenceCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftProcessesByUserIdAndReferenceCodeQueryKey(userId,referenceCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>> = ({ signal }) => getDraftProcessesByUserIdAndReferenceCode(userId,referenceCode, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId && referenceCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDraftProcessesByUserIdAndReferenceCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>>
export type GetDraftProcessesByUserIdAndReferenceCodeQueryError = unknown


export function useGetDraftProcessesByUserIdAndReferenceCode<TData = Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError = unknown>(
 userId: string,
    referenceCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>,
          TError,
          Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDraftProcessesByUserIdAndReferenceCode<TData = Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError = unknown>(
 userId: string,
    referenceCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>,
          TError,
          Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDraftProcessesByUserIdAndReferenceCode<TData = Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError = unknown>(
 userId: string,
    referenceCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDraftProcessesByUserIdAndReferenceCode<TData = Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError = unknown>(
 userId: string,
    referenceCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByUserIdAndReferenceCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDraftProcessesByUserIdAndReferenceCodeQueryOptions(userId,referenceCode,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPendingDraftProcessesByUserIdAndReferenceCode = (
    userId: string,
    referenceCode: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DraftProcessDTO[]>(
      {url: `/api/draftprocess/user/${userId}/reference/${referenceCode}/pending`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPendingDraftProcessesByUserIdAndReferenceCodeQueryKey = (userId?: string,
    referenceCode?: string,) => {
    return [`/api/draftprocess/user/${userId}/reference/${referenceCode}/pending`] as const;
    }

    
export const getGetPendingDraftProcessesByUserIdAndReferenceCodeQueryOptions = <TData = Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError = unknown>(userId: string,
    referenceCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingDraftProcessesByUserIdAndReferenceCodeQueryKey(userId,referenceCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>> = ({ signal }) => getPendingDraftProcessesByUserIdAndReferenceCode(userId,referenceCode, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId && referenceCode), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingDraftProcessesByUserIdAndReferenceCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>>
export type GetPendingDraftProcessesByUserIdAndReferenceCodeQueryError = unknown


export function useGetPendingDraftProcessesByUserIdAndReferenceCode<TData = Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError = unknown>(
 userId: string,
    referenceCode: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>,
          TError,
          Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingDraftProcessesByUserIdAndReferenceCode<TData = Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError = unknown>(
 userId: string,
    referenceCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>,
          TError,
          Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingDraftProcessesByUserIdAndReferenceCode<TData = Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError = unknown>(
 userId: string,
    referenceCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPendingDraftProcessesByUserIdAndReferenceCode<TData = Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError = unknown>(
 userId: string,
    referenceCode: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserIdAndReferenceCode>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingDraftProcessesByUserIdAndReferenceCodeQueryOptions(userId,referenceCode,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPendingDraftProcessesByUserId = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DraftProcessDTO[]>(
      {url: `/api/draftprocess/user/${userId}/pending`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPendingDraftProcessesByUserIdQueryKey = (userId?: string,) => {
    return [`/api/draftprocess/user/${userId}/pending`] as const;
    }

    
export const getGetPendingDraftProcessesByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError = unknown>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPendingDraftProcessesByUserIdQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>> = ({ signal }) => getPendingDraftProcessesByUserId(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPendingDraftProcessesByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>>
export type GetPendingDraftProcessesByUserIdQueryError = unknown


export function useGetPendingDraftProcessesByUserId<TData = Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError = unknown>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>,
          TError,
          Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingDraftProcessesByUserId<TData = Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>,
          TError,
          Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPendingDraftProcessesByUserId<TData = Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetPendingDraftProcessesByUserId<TData = Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError = unknown>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPendingDraftProcessesByUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPendingDraftProcessesByUserIdQueryOptions(userId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDraftProcessesByType = (
    processType: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<DraftProcessDTO[]>(
      {url: `/api/draftprocess/type/${processType}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetDraftProcessesByTypeQueryKey = (processType?: string,) => {
    return [`/api/draftprocess/type/${processType}`] as const;
    }

    
export const getGetDraftProcessesByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getDraftProcessesByType>>, TError = unknown>(processType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftProcessesByTypeQueryKey(processType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDraftProcessesByType>>> = ({ signal }) => getDraftProcessesByType(processType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(processType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDraftProcessesByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getDraftProcessesByType>>>
export type GetDraftProcessesByTypeQueryError = unknown


export function useGetDraftProcessesByType<TData = Awaited<ReturnType<typeof getDraftProcessesByType>>, TError = unknown>(
 processType: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDraftProcessesByType>>,
          TError,
          Awaited<ReturnType<typeof getDraftProcessesByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDraftProcessesByType<TData = Awaited<ReturnType<typeof getDraftProcessesByType>>, TError = unknown>(
 processType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDraftProcessesByType>>,
          TError,
          Awaited<ReturnType<typeof getDraftProcessesByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDraftProcessesByType<TData = Awaited<ReturnType<typeof getDraftProcessesByType>>, TError = unknown>(
 processType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetDraftProcessesByType<TData = Awaited<ReturnType<typeof getDraftProcessesByType>>, TError = unknown>(
 processType: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDraftProcessesByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDraftProcessesByTypeQueryOptions(processType,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



